import { render, staticRenderFns } from "./appPanel.vue?vue&type=template&id=bfc0ca9c&scoped=true"
import script from "./appPanel.vue?vue&type=script&lang=js"
export * from "./appPanel.vue?vue&type=script&lang=js"
import style0 from "./appPanel.vue?vue&type=style&index=0&id=bfc0ca9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc0ca9c",
  null
  
)

export default component.exports